import {useState} from 'react'
import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, skinConcerns} from './answers'

const answers = justValues(skinConcerns)

export const Concerns = () => {
  const {submitAnswers} = useOutletContext()
  const [selectedAnswers, setSelectedAnswers] = useState([])

  const isSelected = answer => selectedAnswers.includes(answer)
  const toggleAnswer = answer => {
    let selected = [...selectedAnswers]
    if (selected.includes(answer)) {
      selected = selected.filter(it => it !== answer)
    } else {
      selected.push(answer)
    }
    setSelectedAnswers(selected)
  }
  const clearAnswers = () => setSelectedAnswers([])
  const submit = (values = selectedAnswers) => submitAnswers(values)
  const clearAndSubmit = () => {
    clearAnswers()
    submit([])
  }

  return (
    <>
      <div className="column">
        <section className="question">
          <div className="content size-xl">My main concerns are...</div>
        </section>
        <section className="answers">
          <div className="content">
            {answers.map(it => (
              <Button
                size="large"
                selected={isSelected(it)}
                action={() => toggleAnswer(it)}
                key={it}
              >
                {it}
              </Button>
            ))}
            <Button
              size="large"
              tone="lowlight"
              action={clearAndSubmit}
            >
              I have no concerns
            </Button>
          </div>
        </section>
      </div>
      <section className="float-bottom">
        <div className="content">
          <Button size="large" action={() => submit()}>Next</Button>
        </div>
      </section>
    </>
  )
}
